import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProductCustomizationsComponent } from '@src/app/features/product-customizations/product-customizations/product-customizations.component';
import { AddProductCustomizationsComponent } from '@src/app/features/product-customizations/add-product-customizations/add-product-customizations.component';
import { ViewProductCustomizationsComponent } from '@app/features/product-customizations/view-product-customizations/view-product-customizations.component';
import { EditProductCustomizationsComponent } from '@src/app/features/product-customizations/edit-product-customizations/edit-product-customizations.component';

const routes: Routes = [
  { path: '', component: ProductCustomizationsComponent },
  { path: 'add', component: AddProductCustomizationsComponent },
  { path: ':productCustomizationId/edit', component: EditProductCustomizationsComponent },
  { path: ':productCustomizationId', component: ViewProductCustomizationsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductCustomizationsRoutingModule { }
